// Words, links and colours that differ between the two brands. The screens take every brand word
// from here, so the EWBS cherry-pick changes this one file. Stored values never change by brand:
// the office meeting type is saved as "OurOffice" on both, only its label differs.
const brand = {
  name: "FDI",
  ourOfficeLabel: "FDI Office",
  crmName: "FDI CRM",
  companyName: "FDI Group of Companies", // the sign-in page's copyright line
  tagline: "Proposals, leads and partner agents for your UAE business setup team, all in one place.",
  websiteUrl: "https://www.fdizone.ae", // "View website" in the header (opens a new tab)
  // A dark wordmark on an opaque white image: always shown inside a white chip, never on colour.
  logo: "/logo/logo.png",
  colorLabel: "FDI navy", // the default theme colour's name in the user menu
  // The default theme colour, a Mantine palette from light to dark: [8] #061c41 is the FDI navy.
  palette: [
    "#e8edf5",
    "#c5d0e6",
    "#a0b2d6",
    "#7a93c6",
    "#5575b6",
    "#3358a6",
    "#1e4496",
    "#0e3070",
    "#061c41",
    "#03102a",
  ],
};

export default brand;
